
import React, { useState } from 'react'
import styled from 'styled-components'
import { LargeButton } from '../components/core'
import { useNavigate } from "react-router-dom";
import SideNav from '../components/sideNav'
import SideNavContent from '../components/sideNavContent'
import routes from "../components/routes";


const ThankYouPage = () => {
    const showSidebar = () => {
        return !!localStorage.getItem('userplan_id')
    }
    let navigate =  useNavigate();
    const redirectToNextPage = () => {
        navigate(`/${routes.MANAGER_DASHBOARD}`)

    }

    
    return (
        <>
            <SideNav>
                {
                    showSidebar() && 
                    <SideNavContent />
                }
                
            </SideNav>
            {/* <HeaderDasNew company_name={company_name} /> */}

            <HomeWrapper>
                <Root>
                <OuterDiv>
                    <TextUpper>Great!</TextUpper>
                    <Text>
                    The company account has been created and the employer has been informed to collect the employee data. You can view this company in the Setup Pending section.
                    </Text>
                </OuterDiv>
                <ButtonWrapper>
                  <LargeButton
                    onClick={redirectToNextPage}
                    id=""
                    label={"Return to Dashboard"}
                    type="submit"
                  />
                </ButtonWrapper>
                </Root>
            </HomeWrapper>
        </>
    )
}
// }

const HomeWrapper = styled.div`
  transition: margin-left .2s ease-in;
  padding: 50px 80px;
  box-sizing: border-box;
  background:#fff;
  height:80vh;
  margin-left: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const OuterDiv = styled.div`
    justify-content: center;
`
const ButtonWrapper = styled.div`
  margin-top: 40px;
  min-width: 400px;
`;
const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 50vh;
  width: 60%;
  padding: 0px 20px 0 20px;
  justify-content: center;
  align-items: center;
`
const TextUpper = styled.p`
  /* margin: 32px 0 24px 0; */
  text-align: center;
  font-family: "Inter";
  font-size: 30px;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4a4a4a;
`

const Text = styled.p`
  margin: 20px 0 10px 0;
  text-align: center;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 22px;
  letter-spacing: normal;
  text-align: center;
  color: #4a4a4a;
`
const Text2 = styled.p`
  margin: 0px 0 24px 0;
  text-align: center;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4a4a4a;
`


export default ThankYouPage